<div aria-hidden="true">
  <input
    *ngFor="let field of honeypots"
    type="text"
    [attr.name]="field.name"
    [(ngModel)]="field.value"
    [ngModelOptions]="{ standalone: true }"
    tabindex="-1"
    autocomplete="off"
    class="host"
  />
</div>
